export const DEV_AUTH = "DEV_AUTH";
export const SET_PROFILE = "SET_PROFILE";
export const LOGOUT = "LOGOUT";
export const LOGIN = "LOGIN";
export const SET_AUTH_PROFILE = "SET_AUTH_PROFILE";
